import * as React from 'react';
import { Container, Stack, Box, Typography } from '@mui/material';
import Grid from "@mui/material/Grid2";
import DeliveryDetailsSection from "../../components/general/checkout/deliveryDetailsSection";
import DeliveryMethodSection from "../../components/general/checkout/deliveryMethodSection";
import PaymentMethodSection from "../../components/general/checkout/paymentMethodSection";
import OrderSummarySection from "../../components/general/checkout/orderSummarySection";
import {useTranslation} from "react-i18next";
import {PRODUCT_INFO} from "../../locales/components/namespaces";
import useCheckoutData from "../../hooks/checkout/useCheckoutData";
import {useCheckout} from "../../hooks/checkout/useCheckout";
import {FormikProvider} from "formik";
import OnlinePaymentRedirectForm from "../onlinePayments/onlinePaymentsRedirectForm";



const Checkout= () => {
    const {t} = useTranslation(PRODUCT_INFO);
    const {
        cartItems,
        vat,
        sum,
        total,
    } = useCheckoutData()

    const {
        formik,
        loading,
        addresses,
        countries,
        currentPayment,
        partneredCarrierOptions,
        recipientCarrierOptions
    } =
        useCheckout({
            onSuccess: (data) => {
               // console.log("order stored", data);
            },
        });



    const shippingValue =
        formik.values.deliveryMethod === "partnered"
            ? t("Cooperating transport companies")
            : formik.values.deliveryMethod === "recipient_transport"
                ? t("Shipping carrier chosen by the recipient")
                : t("Courier");

    return (
        <FormikProvider value={formik}>
            <Box
                sx={{
                    //backgroundColor: '#F5F5F5',
                    minHeight: '100vh',
                    py: { xs: 4, md: 6 },
                    px: { xs: 4, md: 0 },

                }}
            >
                <Grid container spacing={{ xs: 3, md: 3 }} columnSpacing={{ xs: 0, md: 35 }} sx={{display:'flex',justifyContent:'space-evenly'}}>
                    <Grid item xs={12} md={7}>
                        <Typography
                            variant="h4"
                            component="h1"
                            sx={{
                                fontWeight: 800,
                                fontSize:35,
                                fontFamily: "'Zen Maru Gothic', sans-serif",
                                textTransform: 'uppercase',
                                mb: { xs: 3, md: 4 },
                            }}
                        >
                            {t("Complete order")}
                        </Typography>
                        <Stack spacing={4}>
                            <DeliveryDetailsSection
                                t={t}
                                formik={formik}
                                addressOptions={addresses}
                                countryOptions={countries}
                            />
                            <DeliveryMethodSection
                                t={t}
                                formik={formik}
                                partneredCarrierOptions={partneredCarrierOptions}
                                recipientCarrierOptions={recipientCarrierOptions}
                            />
                            <PaymentMethodSection
                                t={t}
                                formik={formik}
                            />
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", md: "flex-end" },
                                width: "100%",
                                mt:  { xs: 0, md: 8 },
                            }}
                        >
                            <OrderSummarySection
                                t={t}
                                formik={formik}
                                items={cartItems}
                                tax={vat}
                                total={total}
                                sum={sum}
                                shippingLabel={shippingValue}
                                loading={loading}
                            />
                        </Box>
                    </Grid>
                </Grid>
                {currentPayment && (
                    <OnlinePaymentRedirectForm
                        currentPayment={currentPayment}
                        language={formik.values.language || "el"}
                    />
                )}
            </Box>
        </FormikProvider>
    );
};

export default Checkout;
